import script from "./winPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./winPopup.vue?vue&type=script&setup=true&lang=ts"

import "./winPopup.vue?vue&type=style&index=0&id=4b50bde4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b50bde4"]])

export default __exports__